import { type Components, type Theme, alpha } from '@mui/material';

const buttonBaseThemeConfig: Components<Theme>['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true,
  },
};

const buttonThemeConfig: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    sizeSmall: { height: '30px', fontSize: '13px' },
    sizeMedium: { height: '36px', fontSize: '14px' },
    sizeLarge: { height: '42px', fontSize: '15px' },

    containedPrimary: {
      backgroundColor: '#01579b',
      textTransform: 'none',
      color: '#fff',
      fontSize: 15,
      fontWeight: 500,
      letterSpacing: '0.46px',
      whiteSpace: 'nowrap',
      '&:hover': {
        backgroundColor: '#00256c',
      },
      '&:focus': {
        backgroundColor: '#01579b',
        outline: '#00B5e2 solid 2px',

        '&:hover': {
          backgroundColor: '#00256c',
        },
      },
      '&:disabled': {
        backgroundColor: alpha('#000000', 0.12), //'#00256c',
        // opacity: 0.6,
        color: alpha('#000000', 0.38), // #fff',
      },
    },
    containedSecondary: {
      backgroundColor: '#fff',
      textTransform: 'none',
      border: '1px solid #01579B',
      boxShadow: 'none',
      color: '#01579b',
      fontSize: 15,
      fontWeight: 500,
      whiteSpace: 'nowrap',

      '&:hover': {
        backgroundColor: '#ccf0f9',
      },
      '&:focus': {
        backgroundColor: '#fff',
        borderColor: '#00b5e2',
        color: '#0085b0',
        outline: '#00B5e2 solid 2px',

        '&:hover': {
          backgroundColor: '#ccf0f9',
          borderColor: '#00b5e2',
          color: '#0085b0',
        },
      },
      '&:disabled': {
        backgroundColor: alpha('#000000', 0.12), //'#00256c',
        color: alpha('#000000', 0.38), // #fff',
        border: 'none',
      },
    },
    containedError: {
      backgroundColor: '#D42828',
      textTransform: 'none',
      border: 'none',
      color: '#fff',
      fontSize: 15,
      fontWeight: 500,
      whiteSpace: 'nowrap',

      '&:hover': {
        backgroundColor: '#9b0000',
      },
      '&:focus': {
        backgroundColor: '#d42828',
        borderColor: '#00b5e2',
        color: '#fff',
        outline: '#00B5e2 solid 2px',

        '&:hover': {
          backgroundColor: '#9b0000',
        },
      },
      '&:disabled': {
        backgroundColor: alpha('#000000', 0.12),
        color: alpha('#000000', 0.38),
      },
    },
    // text button
    containedInfo: {
      backgroundColor: 'transparent',
      textTransform: 'none',
      border: 'none',
      color: alpha('#000000', 0.87), //'#000',
      fontSize: 15,
      fontWeight: 500,
      boxShadow: 'none',
      whiteSpace: 'nowrap',

      '&:hover': {
        backgroundColor: '#d3d4d7',
        textDecoration: 'underline',
      },
      '&:focus': {
        backgroundColor: '#d3d4d7',
        color: '#000',
        outline: '#00B5e2 solid 2px',

        '&:hover': {
          backgroundColor: '#d3d4d7',
          textDecoration: 'underline',
        },
      },

      '&:disabled': {
        backgroundColor: '#d3d4d7',
        color: '#000',
        opacity: 0.6,
      },
    },
  },
};

export const muiButtonThemeConfig = {
  MuiButton: {
    ...buttonThemeConfig,
  },
  MuiButtonBase: {
    ...buttonBaseThemeConfig,
  },
};
